module.exports = __webpack_public_path__ + "img/f-bandcamp.d111051c.svg";